import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-layout',
  templateUrl: './message-layout.component.html',
  styleUrls: ['./message-layout.component.scss']
})
export class MessageLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
